import '../styles/home-kpi-sync-premium.css';

function HomeKpiSyncLoader({
  compact = false,
  showSkeleton = true,
  title = 'Sincronizando asociación',
  hint = 'Cruzando datos entre PLEX y GECLISA…'
}) {
  return (
    <div
      className={`home-kpi-sync${compact ? ' home-kpi-sync--compact' : ''}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="home-kpi-sync__card">
        <div className="home-kpi-sync__status">
          <span className="home-kpi-sync__spinner" aria-hidden="true" />
          <div className="home-kpi-sync__copy">
            <p className="home-kpi-sync__title">{title}</p>
            <p className="home-kpi-sync__hint">{hint}</p>
          </div>
        </div>

        <div className="home-kpi-sync__bridge" aria-hidden="true">
          <span className="home-kpi-sync__node home-kpi-sync__node--plex">
            <span className="home-kpi-sync__node-tag">Farm.</span>
            PLEX
          </span>
          <span className="home-kpi-sync__link">
            <span className="home-kpi-sync__link-track" />
            <span className="home-kpi-sync__link-dot home-kpi-sync__link-dot--a" />
            <span className="home-kpi-sync__link-dot home-kpi-sync__link-dot--b" />
            <span className="home-kpi-sync__link-icon">↔</span>
          </span>
          <span className="home-kpi-sync__node home-kpi-sync__node--gec">
            <span className="home-kpi-sync__node-tag">San.</span>
            GECLISA
          </span>
        </div>

        {showSkeleton ? (
          <div className="home-kpi-sync__skel" aria-hidden="true">
            <span className="home-kpi-sync__skel-row" />
            <span className="home-kpi-sync__skel-row home-kpi-sync__skel-row--md" />
            <span className="home-kpi-sync__skel-row home-kpi-sync__skel-row--sm" />
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default HomeKpiSyncLoader;
